import { App } from '../app/app';
import { getConfig } from '../config/config';
import type { SdkConfig } from '../config/types';

export const DEFAULT_ENTRY_NAME = 'DEFAULT_APP';

export const apps = new Map<string, App>();

export const getApp = (name: string = DEFAULT_ENTRY_NAME): App => {
  const app = apps.get(name);

  if (!app) {
    throw new Error('App must be init');
  }

  return app;
};

export const initializeApp = async (sdkConfig: SdkConfig): Promise<App> => {
  if (apps.has(DEFAULT_ENTRY_NAME)) {
    const currentApp = getApp(DEFAULT_ENTRY_NAME);

    currentApp.logger.log(
      `Application ${DEFAULT_ENTRY_NAME} is already initialized`,
      ['Desert Samourai'],
    );

    return currentApp;
  }

  const config = await getConfig(sdkConfig);

  const newApp = new App(config);

  apps.set(DEFAULT_ENTRY_NAME, newApp);

  return newApp;
};

export const isDefaultAppInitialized = (
  name: string = DEFAULT_ENTRY_NAME,
): boolean => Boolean(apps.get(name));
